import { Navigate, Outlet, Route, Routes, useNavigate } from "react-router-dom";
import { useAuthContext } from "./contexts/AuthContext";
import Client from "./appolo/Client";
import axios from "axios";
import { useEffect, useState } from "react";
import { Spinner, Table } from "react-bootstrap";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { JWT } from "aws-amplify/auth";

const ProtectedRoute = ({ allowedTypes, redirectPath }: any) => {
  const { user, userId } = useAuthContext();
  const [mobileUser, setMobileUser] = useState(null);
  const [mobileToken, setMobileToken] = useState<string>();
  const [client , setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [forceRender, setForceRender] = useState(false); // hack
  const navigate = useNavigate();

  useEffect(() => {
    setForceRender((prev) => !prev); // hack re-render de composant pour client
    if (client !== null) {
      setLoading(false); // Dès que `client` est mis à jour, on retire le loader
    }
  }, [client]);

  // Hack to redirect unconnected people (timeout to let connected user retreive data)
  useEffect(() => {
    if (!user && !mobileUser) {
      setTimeout(() => {
        setLoading(false);
      }, 5000);
    }
  }, [user, mobileUser]);

  // let use cookie instead
  const getCookie = (name: string) => {
    const cookies = document.cookie.split(';');
    // alert('cookie'+ cookies);
    for (let cookie of cookies) {
      const [key, value] = cookie.trim().split('=');
      // alert(key + "..." + value);
      if (key === name) {
        return value;
      }
    }
    return null;
  };

  function decodeJWT(token: string) {
    if (!token) return null;

    try {
        // return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString()); // NODEJS
        const base64Url = token.split('.')[1];
        if (!base64Url) throw new Error("JWT invalide, impossible d'extraire le payload.");

        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const decoded = atob(base64);

        const jsonPayload = decodeURIComponent(
            decoded
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );

        // console.log("Payload final avant JSON.parse :", jsonPayload);

        return JSON.parse(jsonPayload);
    } catch (e) {
        console.error("Erreur lors du décodage du JWT :", e);
        return null;
    }
  }

  const getAuthToken = () => {
    // use Cookie instead
    // const tokenJSON = Cookies.get('authToken');
    const urlParams = new URLSearchParams(window.location.search);
    const jwt = urlParams.get("token");
    setMobileToken(decodeURIComponent(jwt));
    const payload = decodeJWT(jwt);
    if (payload) {
      return payload
    }
    return
  };

  useEffect(() => {
    const token: any = getAuthToken();
    if (token && token.sub) {
      try {
        setMobileUser(token.sub);
      } catch (error) {
        console.error("Erreur de décodage du token:", error);
        alert("Erreur de décodage du token: "+ error);
      }
    }
  }, []);

  useEffect(() => {
    if (user) {
      getUser();
    } else if (mobileUser) {
      getUser();
    }
  } ,[user, mobileUser])

  const getUser = async () => {
    try {
      if (userId) {
        const response = await axios.get("/api/graphql/user/" + userId);
        if (response.data.suspended) {
          setClient(null);
          navigate('/suspended');
          return
        } else if (response.data.com_suspended) {
          navigate('/company_suspended');
          return
        }
        setClient(response.data);
      } else if (mobileUser) {
        const response = await axios.get("/api/graphql/user/" + mobileUser);
        if (response.data.suspended) {
          setClient(null);
          navigate('/suspended');
          return
        }
        setClient(response.data);
      }
    } catch (error) {
      console.error("Erreur de chargement de l'utilisateur :", error.message);
      if (error.response && error.response.status === 500) {
        navigate("/error/500");
      }
    }
  }

  if (loading) {
    return (
      <div></div>
      // <div className="spinnerContainer">
      //     <Spinner animation="border" role="status" className="spinner">
      //         <span className="visually-hidden">Loading...</span>
      //     </Spinner>   
      // </div>
    )
  }
  // console.log('client', client);

  // if (!client) {
  //   return <Navigate to="/" replace />;
  // }
  if (!user && !mobileUser) {
    return <Navigate to={redirectPath || "/signin"} replace />;
  }

  if (!allowedTypes.includes(client?.type)) {
    // console.log('cli',client?.type);
    return <Navigate to={redirectPath} replace />;
  }

  return <Client mobileClient={mobileToken}><Outlet/></Client>;

  // return (
  // <Routes>
  // {/* <Client> */}
  //   <Route path="/" element={<Layout direction={""} />}>
  //   { client?.type === "MANAGER" &&
  //     <>
  //       <Route path="table" element={<Table />} />
  //       <Route path="excel_import" element={<ExcelImport />} />
  //       <Route path="scheduler" element={<SchedulerView />} />
  //       <Route path="agenda/management" element={<AgendaManagerView />} />
  //       <Route path="agenda" element={<AgendaView />} />
  //       <Route path="users" element={<UsersView />} />
  //       <Route path='user/:id' element={<UserView />} />
  //       <Route path='user/shifts/:id' element={<ShiftsByUserView />} />
  //       <Route path='shift/:id' element={<ShiftView />} /> 
  //     </>
  //     }
  //     { client?.type === "EMPLOYEE" &&
  //       <>
  //         <Route path="agenda" element={<AgendaView />} />
  //         <Route path="users" element={<UsersView />} />
  //         <Route path='user/:id' element={<UserView />} />
  //         <Route path='user/shifts/:id' element={<ShiftsByUserView />} />
  //         <Route path='shift/:id' element={<ShiftView />} />
  //       </>
  //     }
  //   </Route>
  // {/* </Client> */}
  // </Routes>
  // );
};

export default ProtectedRoute;
